import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'
import ButtonBase from '@material-ui/core/ButtonBase'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import CheckIcon from '@material-ui/icons/Check'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import SvgIcon from '@material-ui/core/SvgIcon'

import { contains } from 'ramda'

import Paragraph from '../styleguide/Paragraph'
import { Checkbox } from '@material-ui/core'

const styles = theme => ({
  wrapperStyle: { width: '100%', maxWidth: 260 },
  itemStyle: {
    background: '#fff',
    minHeight: 44,
    border: '1px solid #d6d8db',
    borderRadius: 3,
    marginTop: 6
  },
  denseItemStyle: {
    paddingTop: 0,
    paddingBottom: 0
  },
  linkStyle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flex: 1,
    textDecoration: 'none',
    paddingLeft: 12
  },
  buttonStyle: {
    alignSelf: 'stretch',
    width: 44,
    minHeight: 44,
    borderLeft: '1px solid #d6d8db'
  },
  filterIconStyle: {
    width: 16,
    height: 16,
    color: '#d6d8db'
  },
  activeItemStyle: {
    borderColor: '#4b96d2'
  },
  activeLabelStyle: {
    color: '#4b96d2'
  },
  activeButtonStyle: {
    borderColor: '#4b96d2',
    backgroundColor: '#4b96d2'
  },
  checkboxWrapperStyle: {
    height: '32px',
    width: '32px',
    border: '1px solid #d6d8db',
    borderRadius: '4px',
    margin: '6px 6px 0 0',
    backgroundColor: '#fff'
  },
  checkboxRootStyle: {
    width: 30,
    height: 30,
    color: 'transparent',
    '&$checkboxCheckedStyle': {
      color: '#303c49'
    }
  },
  checkboxCheckedStyle: {},
  checkboxIconSize: {
    fontSize: 30
  }
})

const FilterIcon = withStyles(styles)(
  ({ viewBox = '0 0 16 16', classes, ...rest }) => (
    <SvgIcon
      viewBox={viewBox}
      classes={{ root: classes.filterIconStyle }}
      {...rest}
    >
      <g>
        <polygon fill="currentColor" points="3 2 3 3 13 3 13 2" />
        <polygon fill="currentColor" points="7 9 7 14 9 13 9 9 13 4 3 4" />
      </g>
    </SvgIcon>
  )
)

class Item extends Component {
  render() {
    const {
      classes: {
        itemStyle,
        denseItemStyle,
        linkStyle,
        buttonStyle,
        activeItemStyle,
        activeLabelStyle,
        activeButtonStyle,
        checkboxWrapperStyle,
        checkboxRootStyle,
        checkboxCheckedStyle,
        checkboxIconSize
      },
      key,
      id,
      target,
      label,
      isSelected,
      onToggle,
      isMarked,

      enableWebToPrintCheckbox,
      onToggleForPrint,
      isSelectedForPrint
    } = this.props
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {enableWebToPrintCheckbox && (
          <div className={checkboxWrapperStyle}>
            <Checkbox
              checkedIcon={<CheckIcon className={checkboxIconSize} />}
              checked={isSelectedForPrint}
              onChange={onToggleForPrint}
              classes={{
                root: checkboxRootStyle,
                checked: checkboxCheckedStyle
              }}
            />
          </div>
        )}
        <ListItem
          key={key}
          id={id}
          disableGutters
          dense
          className={`${isSelected ? activeItemStyle : ''}`}
          classes={{ root: itemStyle, dense: denseItemStyle }}
        >
          <Link to={target} className={linkStyle}>
            <Paragraph
              condensed
              component="span"
              style={{ display: 'inline-flex' }}
              className={`${isSelected ? activeLabelStyle : ''}`}
            >
              {label}
            </Paragraph>
            <ChevronRightIcon
              nativeColor="#d6d8db"
              style={{ marginRight: 6 }}
            />
          </Link>
          <ButtonBase
            className={`${buttonStyle} ${isSelected ? activeButtonStyle : ''}`}
            onClick={onToggle}
          >
            <FilterIcon
              style={{
                color: isMarked ? '#e40045' : isSelected ? '#fff' : null
              }}
            />
          </ButtonBase>
        </ListItem>
      </div>
    )
  }
}
const StyledItem = withStyles(styles)(Item)

class FilterList extends Component {
  render() {
    const {
      data,
      selectedItemId,
      onItemSelected,
      classes: { wrapperStyle },

      webToPrintModeActive,
      contentSelectedForPrint,
      onToggleForPrint
    } = this.props
    return (
      <div className={wrapperStyle}>
        <List>
          {data.map((item, index) => (
            <StyledItem
              key={item.id}
              id={item.id}
              label={item.title}
              target={item.path}
              onToggle={() => {
                onItemSelected(item.id)
              }}
              isSelected={item.id === selectedItemId}
              isMarked={item.vehicleExclusive}
              enableWebToPrintCheckbox={webToPrintModeActive}
              isSelectedForPrint={contains(
                { slug: item.slug, index },
                contentSelectedForPrint
              )}
              onToggleForPrint={() => {
                onToggleForPrint({ slug: item.slug, index })
              }}
            />
          ))}
        </List>
      </div>
    )
  }
}

export default withStyles(styles)(FilterList)



// WEBPACK FOOTER //
// ./src/components/FilterList.js